
var ViewFactory = require('tplify/dist/viewFactory').default;

delete module.exports;

var viewFactory = new ViewFactory('<h3 data-name="typeRegion">Consignor</h3>\n<p data-property="name"></p>\n<p data-property="street"></p>\n<p data-property="postalString"></p>\n<p data-property="country"></p>\n');

Object.defineProperty(module, 'exports', {
get: function() {
    return viewFactory.create();
}
});
